module.exports = __webpack_public_path__ + "assets/img/icon-car-blue.9dfa61ad.png";